export const fetchFromApi = async (pathname: string): Promise<any> => {
  const result = await fetch(pathname);
  if (!result.ok) {
    const error = await result.text();
    console.error('Could not fetch', error);
    throw new Error(error);
  }

  return result.json();
}
